(function(){
  var tt;
  function toast(msg){
    var t=document.getElementById('mt-toast');
    if(!t){t=document.createElement('div');t.id='mt-toast';t.className='mt-toast';t.setAttribute('role','status');document.body.appendChild(t);}
    t.textContent=msg;t.hidden=false;clearTimeout(tt);tt=setTimeout(function(){t.hidden=true},2000);
  }
  function setCount(n){
    document.querySelectorAll('[data-mt-count]').forEach(function(el){el.textContent=n;el.hidden=!n;});
    document.querySelectorAll('[data-mt-cartlink]').forEach(function(el){el.setAttribute('aria-label','Carrinho com '+n+(n===1?' item':' itens'));});
  }
  var root=(window.Shopify&&Shopify.routes&&Shopify.routes.root)||'/';

  // Adicionar ao carrinho sem sair da página (botões "Adicionar")
  document.addEventListener('submit',function(e){
    var f=e.target;
    if(f.matches('[data-mt-add]')&&!(e.submitter&&e.submitter.name==='return_to')){
      e.preventDefault();
      var btn=f.querySelector('button[type=submit]');if(btn){btn.disabled=true;}
      fetch(root+'cart/add.js',{method:'POST',headers:{'Accept':'application/json'},body:new FormData(f)})
        .then(function(r){if(!r.ok)throw r;return fetch(root+'cart.js')})
        .then(function(r){return r.json()})
        .then(function(c){setCount(c.item_count);if(btn){btn.disabled=false;btn.classList.add('is-done');btn.textContent='No carrinho';}toast('Adicionado ao carrinho');})
        .catch(function(){f.removeAttribute('data-mt-add');f.submit();});
    }
    if(f.matches('[data-mt-coupon]')){
      e.preventDefault();
      var code=(f.querySelector('input').value||'').trim();
      if(code){window.location.href=root+'discount/'+encodeURIComponent(code)+'?redirect='+encodeURIComponent(root+'cart');}
    }
    if(f.matches('[data-mt-lead]')){
      var m=f.querySelector('input[type=email]'),err=f.querySelector('[data-mt-err]');
      if(m&&(!m.value||m.value.indexOf('@')<1||m.value.indexOf('.')<0)){
        e.preventDefault();
        if(err){err.textContent='Confira o e-mail: ele precisa ter @ e um domínio, como voce@email.com.';err.classList.add('mt-err');}
        m.focus();
        return;
      }
      // Pede o e-mail de boas-vindas direto ao Worker, junto com o cadastro na Shopify
      var url=f.getAttribute('data-mt-worker');
      if(url&&m){
        var tk=f.querySelector('[name="cf-turnstile-response"]');
        if(!tk||!tk.value){
          if(window.turnstile){
            e.preventDefault();
            if(err){err.textContent='Só um instante: estamos confirmando que você não é um robô. Tente de novo em alguns segundos.';err.classList.add('mt-err');}
            return;
          }
          return; // o Turnstile não carregou (bloqueador, rede): o cadastro na Shopify segue mesmo assim
        }
        var n=f.querySelector('input[name="contact[first_name]"]');
        try{
          fetch(url,{method:'POST',keepalive:true,headers:{'Content-Type':'text/plain;charset=UTF-8'},
            body:JSON.stringify({email:m.value.trim(),nome:n?n.value.trim():'',origem:f.getAttribute('data-mt-origem')||'',token:tk.value})});
        }catch(x){}
        tk.removeAttribute('name'); // não envia o token do Turnstile para a Shopify
      }
    }
  });

  // Galeria do produto
  document.addEventListener('click',function(e){
    var b=e.target.closest('[data-mt-thumb]');
    if(b){
      var g=b.closest('[data-mt-gal]');var i=b.getAttribute('data-mt-thumb');
      g.querySelectorAll('[data-mt-thumb]').forEach(function(x){x.setAttribute('aria-pressed',x===b)});
      g.querySelectorAll('[data-mt-slide]').forEach(function(s){s.hidden=s.getAttribute('data-mt-slide')!==i});
      var z=g.querySelector('[data-mt-zoom]');if(z){z.textContent=z.getAttribute('data-tpl').replace('{n}',(+i+1))}
    }
    var ft=e.target.closest('[data-mt-filtertoggle]');
    if(ft){var p=document.getElementById(ft.getAttribute('aria-controls'));if(p){var o=p.classList.toggle('is-open');ft.setAttribute('aria-expanded',o)}}
  });

  // Ordenação e filtros enviam sozinhos
  document.addEventListener('change',function(e){
    if(e.target.matches('[data-mt-autosubmit]')){e.target.form.submit();}
  });

  // Índice do artigo gerado pelos H2
  document.querySelectorAll('[data-mt-toc]').forEach(function(box){
    var art=document.querySelector(box.getAttribute('data-mt-toc'));if(!art)return;
    var hs=art.querySelectorAll('h2');if(!hs.length){box.remove();return;}
    hs.forEach(function(h,i){
      if(!h.id){h.id='secao-'+(i+1);}
      var a=document.createElement('a');a.href='#'+h.id;a.textContent=h.textContent;box.appendChild(a);
    });
  });
})();
